import { motion } from 'framer-motion'
import { useStats } from '../../../lib/ctx/stats'
import { css } from '@fable/theme'

interface Props {
  animate?: boolean
  color: string
}

export const StreakCalendarCellBg = ({ animate = false, color }: Props) => {
  const month = useStats((s) => s.streakMonth)

  const styles = css`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: ${color};
  `

  if (animate) {
    return (
      <motion.span
        key={month}
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.6 }}
        className={styles}
      />
    )
  }

  return <span className={styles} />
}
